import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { PHP_DOMAIN, STATUS } from "../../Constants";


// For Get Access Token API
const getAccessTokenEndpoint = (args)=> `${PHP_DOMAIN}?FA2=${args.fa2}&country=EG&password=${args.password}&ip=&port=&username=${args.fbId}&clientCountry=EG` ; 


export const getTokenAPI = createAsyncThunk('user/getTkn' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAccessTokenEndpoint(args) ) ; 
        return response.data.token_lite
    }catch(error){
        return rejectWithValue(error) ; 
    }
})



const initialState = {
    AcessToken : "" , 
    tokenStatus : STATUS.IDLE , 
    lg : localStorage.getItem("i18nextLng") || 'en' , 
    showSide : false
} ;

const UserSlice = createSlice({
    name : "user" , 
    initialState , 
    reducers : {
        handleShowSide : (state)=>{
            state.showSide = !state.showSide
        }

    } , extraReducers : (builder)=>{
        builder.addCase(getTokenAPI.fulfilled , (state , action)=>{
            state.AcessToken = action.payload ; 
            state.tokenStatus = STATUS.SUCCESS ; 
        })
        builder.addCase(getTokenAPI.pending , (state , action)=>{
            state.tokenStatus = STATUS.LOADDING ; 
        })
        builder.addCase(getTokenAPI.rejected , (state , action)=>{
            state.tokenStatus = STATUS.ERROR ; 
            toast.error("Something give error please check id or password or 2FA")
        })
    }
})

export default UserSlice.reducer ;


export const getUserToken = (state)=>state.UserSlice.AcessToken ; 
export const getLanguage = (state)=>state.UserSlice.lg ; 
export const getFBToken = (state) => state.UserSlice ; 
export const getSideStatus = (state)=> state.UserSlice.showSide


export const {handleShowSide} = UserSlice.actions ; 

